<template>
  <div id="count-post-moderation" v-if="hasCount()">
    <div class="alert alert-danger alert-dismissible" role="alert" @click="onClick()">
      <div class="d-flex">
        <template v-if="isPrivate()">
          Заметок на модерации: {{ count }}
        </template>
        <template v-if="isPublic()">
          Постов на модерации: {{ count }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, ref} from "vue"
import { useRouter } from 'vue-router'
import Api from "./services/Api"
import Helper from "@/services/Helper"

export default defineComponent({
  name: "CountPostModeration",
  components: {},
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter()
    let payload = geyPayload()
    let count = ref(0)

    onMounted(() => {
      let typeIds = []
      let typeVisible = null

      if (isPrivate()) {
        typeIds = [5]
        typeVisible = 1
      }

      if (isPublic()) {
        typeIds = [6, 7]
        typeVisible = 2
      }

      getCount(typeIds, typeVisible).then((resp) => {
        count.value = resp
      })
    })

    function isPrivate() {
      return payload.typeVisible === 1
    }

    function isPublic() {
      return payload.typeVisible === 2
    }

    function isSiteChannel(channelId) {
      return Helper.inArray([channelId], [1])
    }

    function onClick() {
      if (isSiteChannel(payload.channelId)) {
        if (isPrivate()) {
          router.push({name: "NotesNotModerated"})
        }

        if (isPublic()) {
          router.push({name: "PostsNotModerated"})
        }
      }
    }

    async function getCount(typeIds, typeVisible) {
      if (isSiteChannel(payload.channelId)) {
        return await Api.count(typeIds, typeVisible)
      }
    }

    function geyPayload() {
      let channelId = null
      let typeVisible = null

      if (Helper.inArray([props.payload.type_visible], [1, 2])) {
        typeVisible = props.payload.type_visible
      }

      if (typeof props.payload.channel_id === "number") {
        channelId = props.payload.channel_id
      }

      return {
        channelId,
        typeVisible,
      }
    }

    function hasCount() {
      return count.value > 0
    }

    return {
      onClick,
      count,
      hasCount,
      isPrivate,
      isPublic,
    }
  }
})
</script>

<style scoped>
  #count-post-moderation .alert {
    font-size: 16px
  }
  #count-post-moderation .alert:hover {
    cursor: pointer;
  }
</style>
